













































import {
  computed,
  defineComponent,
  PropType,
  ref,
} from '@nuxtjs/composition-api';

import {
  SfLoader,
} from '@storefront-ui/vue';
import ReviewsMobile from '~/components/Palmers/Product/Reviews/ReviewsMobile.vue';
import Accordion from "~/components/Palmers/BaseComponents/Accordion/Accordion.vue";
import ProductAddReviewForm from '~/components/Palmers/Product/ReviewForm/ProductAddReviewForm.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import Rating from '~/components/Palmers/Product/Rating/Rating.vue';
import reviewGetters, {
  getTotalReviews,
  getReviewId,
  getReviewAuthor,
  getReviewDate,
  getReviewMessage,
  getReviewRating,
} from '~/modules/review/getters/reviewGetters';
import {useReview, UseReviewAddReviewParams} from '~/modules/review/composables/useReview';
import {Product} from '~/modules/catalog/product/types';
import {usePageStore} from '~/stores/page';

export default defineComponent({
  name: 'ProductTabs',
  components: {
    ProductAddReviewForm,
    HTMLContent,
    Rating,
    ReviewsMobile,
    Accordion,
    SfLoader,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    rating: {
      type: [Number, String, Boolean],
      default: false,
    },
    maxRating: {
      type: [Number, String],
      default: 5,
    },
  },
  setup(props, {emit}) {
    const totalReviews = computed(() => getTotalReviews(props.product));
    const ratingCustom = Number(props.rating) / 20;
    const {routeData} = usePageStore();
    const reviews = ref(null);
    const isReviewsLoading = ref(true);
    const {
      search: searchReviews,
      addReview,
    } = useReview();

    const getSearchQuery = () => ({
      filter: {
        sku: {
          eq: routeData.sku,
        },
      },
    });

    const fetchReviews = async (query = getSearchQuery()) => {
      const productReviews = await searchReviews(query, props.product.stock_status, props.product.id);
      const baseReviews = Array.isArray(productReviews)
        ? productReviews?.[0]
        : productReviews;

      reviews.value = reviewGetters.getItems(baseReviews);
    };

    let lastReviewsQuery = '';

    const newQuery = getSearchQuery();
    const stringNewQuery = JSON.stringify(newQuery);
    if (lastReviewsQuery !== stringNewQuery) {
      lastReviewsQuery = stringNewQuery;
      fetchReviews(newQuery);
      isReviewsLoading.value = false;
    }

    const successAddReview = async (reviewData: UseReviewAddReviewParams) => {
      await addReview(reviewData);
      document.querySelector('#tabs').scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    };

    return {
      totalReviews,
      reviews,
      isReviewsLoading,
      ratingCustom,
      getReviewId,
      getReviewAuthor,
      getReviewDate,
      getReviewMessage,
      getReviewRating,
      successAddReview,
    };
  },

  methods: {
    getReviewRatingCustom(item) {
      return Number.parseInt(
        item.ratings_breakdown[0]?.value,
        10,
      ) || 0;
    },
    getReviewSummary(item) {
      return item.summary;
    },
  }
});
